import request from '@/utils/request';

/**
 * 创建微信支付订单
 * @param {string} orderID - 订单ID
 * @returns {Promise} 返回包含二维码URL和过期时间的支付信息
 */
export function createWechatPay(orderID) {
  return request({
    url: `/order-server/customer/orders/${orderID}/wechat/pay`,
    method: 'post'
  });
}

/**
 * 查询微信支付状态
 * @param {string} orderID - 订单ID
 * @returns {Promise} 返回支付状态信息
 */
export function queryWechatPayStatus(orderID) {
  return request({
    url: `/order-server/customer/orders/${orderID}/wechat/status`,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/wechatPay.js